<template>
    <div ref="modal" class="modal fade" :class="{ show: active, 'd-block': active }" tabindex="-1" role="dialog">
      <div class="modal-dialog modal-lg" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">Manual Shipped</h5>
            <button type="button" class="btn-close" data-bs-dismiss="modal" v-on:click="$emit('closeModal')"
              aria-label="btn-close"></button>
          </div>
  
          <div class="modal-body">
  
            <div class="row">

              <div class="table-responsive">
                              <table class="table table-hover" style="height: 300px">
                                <thead>

                                  <tr>
                                    <th>#</th>
                                    <th width="150px" class="required">SKU</th>
                                    <th width="150px">SKU Description</th>
                                    <th class="required">Qty Order</th>
                                    <th class="required">Qty Received</th>
                                    
                                  
                                  </tr>
                                </thead>
                                <tbody>
                                  <tr v-for="(input, index) in this.data" :key="`phoneInput-${index}`">
                                    <th>{{ index + 1 }}</th>

                                    <td width="100px">


                                      <!-- <multiselect style="width:200px;" @search-change="asyncSearchSku"
                                        v-model="input.sku" :options="fetchSku" @input="cekData(index, detailPo)"
                                        label="sku" track-by="sku" placeholede="Please Select SKU">
                                        <span slot="noResult">Oops! No elements found. Consider changing the
                                          search query.</span>
                                      </multiselect> -->
                                      {{ input.sku }}

                                    </td>

                                    <td>

                                      {{ input.skuDescr }}
                                      <!-- <input readonly  type="number" v-model="input.volume" class="form-control" style="width: 100px" /> -->
                                    </td>

                                    <td>
                                      <!-- <input readonly  type="number" v-model="input.orderedQty" class="form-control" required
                                        style="width: 100px" /> -->
                                        {{ input.expectedQty }}
                                    </td>

                                    <td>
                                      <input  type="number" v-model="input.receivedQty" class="form-control"
                                        style="width: 100px" />

                                        <!-- {{ input.totalCubic }} -->
                                    </td>

                                    

                                  

                                
                                  

                                   
                                  
                                 
                                   


                                   

                                   

                                    

                                   

                                   

                                  

                                   



                                
                                   
                                  </tr>
                                </tbody>

                                <tfoot></tfoot>
                              </table>
                            </div>
              
            </div>
          </div>
  
          <div class="modal-footer">
            <button type="button" class="btn btn-secondary" v-on:click="$emit('closeModal')">
              cancel
            </button>
            <button class="btn btn-success" type="submit" v-on:click="saveAssign">
              <span v-if="isLoading" class="spinner-border spinner-border-sm ms-auto" role="status"
                aria-hidden="true"></span>Save
            </button>
          </div>
  
        </div>
      </div>
    </div>
  </template>
  
  <script>
  
  export default {
   
    name: "ModalManualShipped",
    emits: ["closeModal"],
    props: {
      showModal: Boolean,
      data: null,
      idAsnHeader:null,
    },
    watch: {
    showModal: {
      handler(newVal) {
        console.log(this.data);
        this.active = newVal;
      
        const body = document.querySelector("body");
        this.showModal
          ? body.classList.add("modal-open")
          : body.classList.remove("modal-open");
      },
      immediate: true,
      deep: true,
    },
    },
    data() {
      return {
        classColapsed: '',
        isLoading: false,
        active: this.showModal,
        forms: [],
        errors: [],
        locale: [],
        fetch_auto_load:[],
        auto_load:"",
        report_date: [],
        pickup_date: "",
        delivery_date: "",
        groupByCategory: [],
        type_error: [],
        rows: [],
        prioritycek: [],
       
      };
    },
    methods: {
      resetForm() {
        this.forms = [];
      },
  
      reset() {
        this.groupByCategory = [];
      
      },
  
   

      saveAssign() {
      this.isLoading = true;

      var DOC_ASN_DETAILS = [];

      var errorValidasi=[
        
      ];

      for (let index = 0; index < this.data.length; index++) {

        if(this.data[index].receivedQty > this.data[index].expectedQty){
          const textMessages="Error Received Qty more than qty ordered with SKU :"+this.data[index].sku;
         
          errorValidasi.push(textMessages);

        }else{


          const element = {
            "idAsnDetail":this.data[index].idAsnDetail, 
            "receivedQty":this.data[index].receivedQty,
          }
      

          DOC_ASN_DETAILS.push(element);

        }
     

      }

      console.log(errorValidasi);

      if(errorValidasi.length==0){
          var dataSend={
            DOC_ASN_DETAILS:DOC_ASN_DETAILS
          }

          console.log(this.forms);
          const baseURI =  this.$settings.endPointFluxOms + "v2/asn/manual-receive/"+this.idAsnHeader;
          this.$http.post(baseURI, dataSend, { timeout: 10000 }).then((response) => {
            this.loading();
            if (response.data.status === 200) {
              //this.resetForm();
              this.isLoading = false;
              this.errors = [];
            
              this.success('Berhasil');
              this.$emit("closeModal");

            } else {
              this.isLoading = false;
              this.errors = response.data.errors;
              this.resultError(response.data.errors);
            }
          }).catch(error => {
            // this.loading();
            this.isLoading = false;
            if (error.code == "ECONNABORTED") {
              this.error("Please Check Your Internet Connection");
            }

            if (error.response) {
              console.log(error.response.data.errors);
              if (error.response.status === 422) {
                this.errors = error.response.data.errors;
                this.resultError(error.response.data.errors);
              } else if (error.response.status === 401) {
                this.logout();
              } else if (error.response.status === 403) {
                this.$router.push("/authorized-error");
              } else if (error.response.status === 500) {
                this.$router.push('/server-error');
              } else {
                this.$router.push('/page-not-found');
              }
            }
            //this.resetForm();
          });
      }else{
        this.resultError(
          {
            messages:errorValidasi
          }
        );
      }

     

    },


    resultError(data) {
      var count = Object.keys(data).length;
      for (var x = 0; x < count; x++) {
        var nameOb = Object.keys(data)[x];
        var objectData = data[nameOb];
        for (var y = 0; y < objectData.length; y++) {
          this.errorAlert(objectData[y]);
        }
      }
    },
     
  
      success2(msg) {
        this.$swal({
          icon: 'info',
          backdrop: true,
          title: "Information",
          html: "<p>* " + msg + "</p>",
          showConfirmButton: true,
          allowOutsideClick: false,
          allowEscapeKey: false
        })
      },
  
  
      errorAlert(msg) {
        this.$swal({
          icon: 'danger',
          backdrop: true,
          title: "Information",
          html: "<p>* " + msg + "</p>",
          showConfirmButton: true,
          allowOutsideClick: false,
          allowEscapeKey: false
        })
      },
  
  
    
  
   
     
      
  
   
      
  
     
    
  
  
  
    },
    mounted() {
      //tail(this.data);
    },
  };
  </script>
  
  <style scoped>
  .modal {
    background: rgba(0, 0, 0, 0.4);
  }
  
  .modal-content {
    background: #fff;
    border-radius: 0px;
    border: none;
    box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.2);
    padding: 0px;
    width: 100%;
    height: 100%;
    margin-left:0px !important;
  }
  </style>